import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import SystemComponentDetailViewModel from "viewModels/administration/systemComponents/systemComponentDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import SystemComponentForm from "./systemComponentForm";

const SystemComponentDetailView: ViewComponent<SystemComponentDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<SystemComponentForm vm={vm} />} />;
});

registerView(SystemComponentDetailView, SystemComponentDetailViewModel);
